var _mask, _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirstMugAngle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 54,
    viewBox: "0 0 64 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_13046_25421",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 17.7909 1.79086 16 4 16H18V32H4C1.79086 32 0 30.2091 0 28V20Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-4 20C-4 15.5817 -0.418278 12 4 12H19L17 20H4H-4ZM19 36H4C-0.418278 36 -4 32.4183 -4 28H4H17L19 36ZM4 36C-0.418278 36 -4 32.4183 -4 28V20C-4 15.5817 -0.418278 12 4 12V20V28V36ZM19 12V36L17 28V20L19 12Z",
    fill: "#CCCCCC",
    mask: "url(#path-1-inside-1_13046_25421)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 24,
    r: 22,
    stroke: "#CCCCCC",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 48,
    r: 6,
    fill: "#3D98F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstMugAngle);
export default __webpack_public_path__ + "static/media/first-mug-angle.6525984cfb734454882b93ff984dc73d.svg";
export { ForwardRef as ReactComponent };